import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "length",
})
export class LengthPipe implements PipeTransform {
	transform<T extends Array<any>>(value: T, fallback: number = 0): number {
		return value?.length ?? fallback;
	}
}
